











import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ChangeLanguage from '@/mixins/ChangeLanguage';
import FetchLocations from '@/mixins/FetchLocations';
import LanguagePicker from '@/components/LanguagePicker.vue';
import Location from '@/location/Location';
import LocationContract from '@/location/LocationContract';
import OverviewMap from '@/components/overview/OverviewMap.vue';
import SearchPanel from '@/components/search/SearchPanel.vue';

@Component({
    components: {
        SearchPanel,
        LanguagePicker,
        OverviewMap,
    },
})
export default class Home extends mixins(ChangeLanguage, FetchLocations) {
    private get locations(): Array<LocationContract> {
        return Location.all();
    }

    private navigateToLocation(location: LocationContract): void {
        const to = this.$router.resolve({
            name: 'location',
            params: {
                locale: this.currentLanguage.code,
                location: location.id,
            },
        });

        this.$router.push(to.location);
    }
}
